import * as formatHelper from "../../helpers/formatHelper";

/**
 * @class ColorantConsumption
 */
export default class ColorantConsumption {
    /**
     * @param {Object}          channels
     * @param {String | null}   date
     */
    constructor(channels, date) {
        this._channels = channels;
        this._date = date === null ? null : new Date(date);
    }

    /**
     * @return {Object}
     */
    get channels() {
        return this._channels;
    }

    /**
     * @param {Object} channels
     */
    set channels(channels) {
        this._channels = channels;
    }

    /**
     * @return {Object}
     */
    get date() {
        return this._date;
    }

    /**
     * @param {Object}  date
     */
    set date(date) {
        this._date = date;
    }

    /**
     * @return {String}
     */
    formatDate() {
        if (this._date !== null) {
            return formatHelper.formatDate(this._date);
        }

        return "";
    }
}
